import { useState, useCallback } from "react";
import { isFunction } from "lodash";
import MuiPhoneNumber from "material-ui-phone-number";
import { makeStyles } from "@material-ui/core/styles";
import { validatePhoneNumber } from "../../utils/validation";
import { t } from 'application-translator/dist/translate/translate.react.js';

const useStyles = makeStyles(() => ({
  textField: {
    [`& fieldset`]: {
      borderRadius: 0,
    },
    "& .MuiInputBase-input": {
      background: "#fff",
    },
    "& .MuiOutlinedInput-adornedStart": {
      background: "#fff",
    },
  },
}));

const Phone = ({
  id = "phone-field",
  callback,
  initValue,
  error = false,
  countryCode = "au",
  ...props
}) => {
  const [phone, setPhone] = useState(initValue || "");
  const classes = useStyles();
  const [status, setStatus] = useState({
    error: false,
    message: null,
  });

  const inputCallback = useCallback(
    (value, countryCode) => {
      const valSplit = value.split(' ');

      if(valSplit[1] && valSplit[1].charAt(0) === '0') {
        valSplit[1] = valSplit[1].slice(1)
      }
      const newValue = valSplit.join(' ')

      setPhone(newValue);

      const { error, message } = validatePhoneNumber(newValue, countryCode);

      setStatus({ error, message });

      if (isFunction(callback)) {
        callback({ value: newValue, countryCode, error, message });
      }
    },
    [callback]
  );

  return (
    <div className="grid gap-2 phone-fld-grp animate-fade-in z-100">
      <MuiPhoneNumber
        defaultCountry={countryCode}
        id={id}
        regions={['america', 'europe', 'asia', 'oceania', 'africa', 'north-america', 'south-america', 'central-america', 'carribean', 'european-union', 'ex-ussr', 'middle-east', 'north-africa']}
        fullWidth={true}
        countryCodeEditable={false}
        onChange={inputCallback}
        value={phone}
        autoFormat={true}
        variant="outlined"
        label={t('Mobile Number')}
        placeholder={"021 452 3872"}
        disableAreaCodes={true}
        error={status.error || error}
        className={classes.textField}
        helperText={status.message}
        enableLongNumbers={true}
        {...props}
      />
    </div>
  );
};

export default Phone;
